const initState = {
    message: "Hello you!",
};

const helloReducer = (state = initState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export default helloReducer;
